function videoInview() {
  const videos = document.querySelectorAll('.js-video-inview');
  if (videos.length === 0) return;

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    videos.forEach((video) => {
      video.pause();
    });
    return;
  }

  if (!('IntersectionObserver' in window)) {
    return;
  }

  const inView = new Set();

  const playVideo = (video) => {
    const promise = video.play();
    if (promise && typeof promise.catch === 'function') {
      promise.catch(() => {});
    }
  };

  const resumeInView = () => {
    inView.forEach((video) => {
      playVideo(video);
    });
  };

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        const video = entry.target;
        if (entry.isIntersecting) {
          inView.add(video);
          playVideo(video);
        } else {
          inView.delete(video);
          video.pause();
        }
      });
    },
    { rootMargin: '200px 0px' }
  );

  videos.forEach((video) => {
    observer.observe(video);
  });

  window.addEventListener('pageshow', (event) => {
    if (event.persisted) {
      resumeInView();
    }
  });

  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') {
      resumeInView();
    }
  });
}

export { videoInview };
